import React from 'react';
import { useNavigate } from 'react-router-dom';

const Header = () => {
    const navigate = useNavigate();
    const userString = localStorage.getItem('logged_user');
    let user = null;

    if (userString) {
        try {
            user = JSON.parse(userString);
        } catch (error) {
            console.error('Error parsing user data:', error);
        }
    }

    const handleSession = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('logged_user');
        navigate('/');
    }

    return (
        <div style={{ color: 'white' }} className="d-flex flex-column align-items-center">
            <div className="d-flex p-4 gap-5">
                <div><strong>BIENVENID@:</strong>  {user?.PER_ASPI_NOMBRES + ' ' + user?.PER_ASPI_APELLIDO_PATERNO + ' ' + user?.PER_ASPI_APELLIDO_MATERNO}</div>
                <div><strong>FECHA DE REGISTRO:</strong>  {user?.PER_ASPI_FECHA_REGISTRO.substring(0, 10)}</div>
            </div>
            <div style={{ textAlign: 'center' }}>
                <h2 style={{ fontSize: 28 }}>OFERTA DE SERVICIOS</h2>
            </div>
            <div className="dropdown d-md-none my-2">
                <button className="btn btn-secondary header-fix dropdown-toggle" type="button" id="dropdownMenuButton2" data-bs-toggle="dropdown" aria-expanded="false">
                    MENU
                </button>
                <ul className="dropdown-menu dropdown-menu-dark" aria-labelledby="dropdownMenuButton2">
                    <li><a className="dropdown-item active" href="/hojadevida/perfil">Perfil</a></li>
                    <li><a className="dropdown-item" href="/hojadevida/personales">Hoja de Vida</a></li>
                    <li><a className="dropdown-item" href="/hojadevida/imprimir">Imprimir</a></li>                    
                    <li><a className="dropdown-item" onClick={() => handleSession()}>Cerrar Sesión</a></li>
                </ul>
            </div>
        </div>
    )
}

export default Header;